import React, {Component} from 'react';
import {connect} from "react-redux";

class ParametersNotice extends Component {

	render() {

		const {parameters} = this.props;

		return (
			<React.Fragment>

				{parameters.length > 0 &&
				<React.Fragment>
					<div className="parameterNotice">
						<p>You currently have some custom parameters that can be used in this section. Whenever you see the word "Source" you can select the option "Custom Parameter" and then choose one of your custom parameters:</p>
						<ul>
							{parameters.map(parameter => <li key={parameter.name}><strong>{parameter.name}</strong></li>)}
						</ul>
					</div>
				</React.Fragment>
				}
			</React.Fragment>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(ParametersNotice);
